import { Box, Skeleton } from '@mui/material';
import { PDVThemeColors } from './PDVThemes';

interface IPDVLoadingSkeletonProps {
  colors: PDVThemeColors;
}

// Substitui o LoadingScreen (spinner cheio) na espera do status do caixa —
// imita o esqueleto da tela real (header, barra de lançamento, área de itens,
// subtotal, rodapé) em vez de travar com um spinner sem contexto nenhum.
export const PDVLoadingSkeleton: React.FC<IPDVLoadingSkeletonProps> = ({ colors }) => (
  <Box
    width="100%"
    height="100dvh"
    display="flex"
    flexDirection="column"
    gap={1}
    sx={{
      p: 1,
      boxSizing: 'border-box',
      bgcolor: colors.backgroundColor ?? '#f5f5f5',
    }}
  >
    {/* Header */}
    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ height: { xs: 46, md: 60 }, px: 2 }}>
      <Skeleton variant="rounded" width={110} height={28} sx={{ borderRadius: 1.5 }} />
      <Skeleton variant="rounded" width={160} height={32} sx={{ borderRadius: 1.5 }} />
    </Box>

    {/* Barra de lançamento */}
    <Box display="flex" gap={1} sx={{ height: { xs: 68, sm: 76, md: 84, lg: 92, xl: 100 } }}>
      <Skeleton variant="rounded" sx={{ flex: '0 0 14%', height: '100%', borderRadius: 2 }} />
      <Skeleton variant="rounded" sx={{ flex: 1, height: '100%', borderRadius: 2 }} />
      <Skeleton variant="rounded" sx={{ flex: '0 0 14%', height: '100%', borderRadius: 2 }} />
    </Box>

    {/* Área de itens do carrinho */}
    <Skeleton variant="rounded" sx={{ flex: 1, borderRadius: 2, minHeight: 120 }} />

    {/* Subtotal */}
    <Box display="flex">
      <Skeleton variant="rounded" width="50%" height={44} sx={{ borderRadius: 2 }} />
    </Box>

    {/* Rodapé */}
    <Skeleton variant="rounded" height={56} sx={{ borderRadius: 2 }} />
  </Box>
);
